import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import NumberField from './NumberField';
import EventLocation from './EventLocation';

const { FiCalendar, FiUsers } = FiIcons;

function EventSetup({ settings, onChange, onPreset }) {
  return (
    <section className="panel setup-panel">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Planning assumptions</span>
          <h2>Conference profile</h2>
        </div>
        <div className="preset-group" aria-label="Budget presets">
          {['Essential', 'Balanced', 'Premier'].map((preset) => (
            <button key={preset} onClick={() => onPreset(preset)}>
              {preset}
            </button>
          ))}
        </div>
      </div>

      <div className="setup-grid">
        <label className="field field-wide">
          <span className="field-label">Conference name</span>
          <div className="input-shell">
            <SafeIcon icon={FiCalendar} className="input-icon" />
            <input
              type="text"
              value={settings.eventName}
              onChange={(event) => onChange('eventName', event.target.value)}
            />
          </div>
        </label>

        <NumberField
          label="Expected attendees"
          value={settings.attendees}
          onChange={(value) => onChange('attendees', value)}
          helper="Used for cost-per-attendee"
        />
        <NumberField
          label="Conference days"
          value={settings.days}
          onChange={(value) => onChange('days', value)}
          min={1}
          suffix="days"
        />
        <NumberField
          label="Approved budget"
          value={settings.budgetCap}
          onChange={(value) => onChange('budgetCap', value)}
          prefix="$"
          step={1000}
        />
      </div>

      <EventLocation settings={settings} onChange={onChange} />

      <div className="profile-note">
        <SafeIcon icon={FiUsers} />
        <span>
          Assumptions update all totals, efficiency metrics, and recommendations
          instantly.
        </span>
      </div>
    </section>
  );
}

export default EventSetup;